// extracted by mini-css-extract-plugin
module.exports = {"base":"fourColStoriesWithLoadMore-m__base__10csd","wrapper":"fourColStoriesWithLoadMore-m__wrapper__1eE7L","load-more":"fourColStoriesWithLoadMore-m__load-more__3cDcG"};